import api from './api';

const autopilotCampaignService = {
    // Campaign Management
    getCampaigns: async (params = {}) => {
        const response = await api.get('/api/autopilot/campaigns', { params });
        return response.data;
    },

    getCampaign: async (id) => {
        const response = await api.get(`/api/autopilot/campaigns/${id}`);
        return response.data;
    },

    createCampaign: async (campaignData) => {
        const response = await api.post('/api/autopilot/campaigns', campaignData);
        return response.data;
    },

    updateCampaign: async (id, campaignData) => {
        const response = await api.put(`/api/autopilot/campaigns/${id}`, campaignData);
        return response.data;
    },

    startCampaign: async (id) => {
        const response = await api.post(`/api/autopilot/campaigns/${id}/start`);
        return response.data;
    },

    pauseCampaign: async (id) => {
        const response = await api.post(`/api/autopilot/campaigns/${id}/pause`);
        return response.data;
    },

    deleteCampaign: async (id) => {
        const response = await api.delete(`/api/autopilot/campaigns/${id}`);
        return response.data;
    },

    sourceCandidates: async (id) => {
        const response = await api.post(`/api/autopilot/campaigns/${id}/source`);
        return response.data;
    },

    getCampaignAnalytics: async (id) => {
        const response = await api.get(`/api/autopilot/campaigns/${id}/analytics`);
        return response.data;
    },

    // Queue Management
    getQueue: async (params = {}) => {
        const response = await api.get('/api/autopilot/queue', { params });
        return response.data;
    },

    getQueueItem: async (id) => {
        const response = await api.get(`/api/autopilot/queue/${id}`);
        return response.data;
    },

    approveCandidate: async (id, options = {}) => {
        const response = await api.post(`/api/autopilot/queue/${id}/approve`, options);
        return response.data;
    },

    rejectCandidate: async (id, reason) => {
        const response = await api.post(`/api/autopilot/queue/${id}/reject`, { reason });
        return response.data;
    },

    skipCandidate: async (id) => {
        const response = await api.post(`/api/autopilot/queue/${id}/skip`);
        return response.data;
    },

    bulkApprove: async (queueItemIds, sendEmail = true) => {
        const response = await api.post('/api/autopilot/queue/bulk-approve', { queueItemIds, sendEmail });
        return response.data;
    },

    bulkReject: async (queueItemIds, reason) => {
        const response = await api.post('/api/autopilot/queue/bulk-reject', { queueItemIds, reason });
        return response.data;
    },

    updateOutreach: async (id, outreachData) => {
        const response = await api.put(`/api/autopilot/queue/${id}/outreach`, outreachData);
        return response.data;
    },

    regenerateOutreach: async (id, style) => {
        const response = await api.post(`/api/autopilot/queue/${id}/regenerate-outreach`, { style });
        return response.data;
    },

    recordResponse: async (id, responseData) => {
        const response = await api.post(`/api/autopilot/queue/${id}/response`, responseData);
        return response.data;
    },

    // Scheduling
    scheduleInterview: async (id, scheduleData) => {
        const response = await api.post(`/api/autopilot/queue/${id}/schedule-interview`, scheduleData);
        return response.data;
    },

    autoSchedule: async (id, options = {}) => {
        const response = await api.post(`/api/autopilot/queue/${id}/auto-schedule`, options);
        return response.data;
    },

    getAvailableSlots: async (id) => {
        const response = await api.get(`/api/autopilot/queue/${id}/available-slots`);
        return response.data;
    },

    cancelInterview: async (id, reason) => {
        const response = await api.post(`/api/autopilot/queue/${id}/cancel-interview`, { reason });
        return response.data;
    },

    // Follow-ups
    getFollowUpStatus: async (id) => {
        const response = await api.get(`/api/autopilot/queue/${id}/follow-up-status`);
        return response.data;
    },

    pauseFollowUps: async (id) => {
        const response = await api.post(`/api/autopilot/queue/${id}/pause-follow-ups`);
        return response.data;
    },

    resumeFollowUps: async (id) => {
        const response = await api.post(`/api/autopilot/queue/${id}/resume-follow-ups`);
        return response.data;
    }
};

export default autopilotCampaignService;
